

































































































































import Vue from 'vue'
import { getRegions, getSubregions } from '~/api/Address/address'
import { carAgencyController, carOfficeController } from '~/api/RentalCar'
import AppView from '~/components/AppView.vue'
import Autocomplete from '~/components/Autocomplete.vue'
import PhoneTextField from '~/components/PhoneTextField.vue'
import TableSwitch from '~/components/TableSwitch.vue'
import TimePicker from '~/components/TimePicker.vue'
import { TableHeader } from '~/utils/interfaces'
import { CarOffice } from '~/utils/interfaces/rentalCar'
export default Vue.extend({
  components: {
    AppView,
    PhoneTextField,
    Autocomplete,
    TableSwitch,
    TimePicker,
  },
  data() {
    return {
      controller: carOfficeController,
      headers: [
        {
          text: this.$t('name'),
          value: 'name',
        },
        {
          text: this.$t('car_agency'),
          value: 'car_agency_name',
        },
        {
          text: this.$t('email'),
          value: 'email',
        },
        {
          text: this.$t('phone'),
          value: 'phone',
        },
        {
          text: this.$t('opening_time'),
          value: 'opening_time',
        },
        {
          text: this.$t('closing_time'),
          value: 'closing_time',
        },
        {
          text: this.$t('is_airport'),
          value: 'is_airport',
        },
        {
          text: this.$t('allow_pick_up'),
          value: 'allow_pick_up',
        },
        {
          text: this.$t('allow_drop_off'),
          value: 'allow_drop_off',
        },
        {
          text: this.$t('address'),
          value: 'address',
        },
        {
          text: this.$t('is_active'),
          value: 'is_active',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ] as TableHeader<CarOffice>[],
      defaultCrud: {
        address: '',
        car_agency: '',
        email: '',
        name: '',
        phone: '',
        description: '',
        is_airport: false,
        allow_pick_up: true,
        allow_drop_off: true,
        subregion: '',
        region: '',
        latitude: null,
        longitude: null,
        opening_time: '',
        closing_time: '',
      },
    }
  },
  methods: {
    getCarAgencies: carAgencyController.getter,
    getRegions,
    getSubregions,
  },
})
